import { Action } from '@ngrx/store';
import { ChallengeDetailsRequestModel } from '~app/modules/checkout/models';
import { ErrorResponse } from '~shared/modules/error-handler';
import { Address, AvailablePaymentMethods, ChallengeResponse, OrderPayment, PaymentRequest } from '../../models';

export enum PaymentActionTypes {
  INIT_PAYMENT = '[app-checkout/Checkout] Init payment',
  INIT_PAYMENT_SUCCESS = '[app-checkout/Checkout] Init payment Success',
  INIT_PAYMENT_FAILURE = '[app-checkout/Checkout] Init payment Failure',

  MAKE_PAYMENT = '[app-checkout/Checkout] Make payment',
  MAKE_PAYMENT_SUCCESS = '[app-checkout/Checkout] Make payment Success',
  MAKE_PAYMENT_FAILURE = '[app-checkout/Checkout] Make payment Failure',
  MAKE_PAYMENT_OTHER_FAILURE = '[app-checkout/Checkout] Make payment other Failure',

  INIT_ADYEN_3DS_FLOW = '[app-checkout/Checkout] Init adyen 3DS flow',
  CANCEL_ADYEN_3DS_FLOW = '[app-checkout/Checkout] Cancel adyen 3DS flow',
  ADYEN_3DS_DETAILS = '[app-checkout/Checkout] Adyen 3DS capture details',

  INIT_PAYPAL_FLOW = '[app-checkout/Checkout] Init paypal flow',
  PAYPAL_DETAILS = '[app-checkout/Checkout] Paypal capture details',
  CANCEL_PAYPAL_FLOW = '[app-checkout/Checkout] Cancel Paypal flow',

  INIT_SOFORT_FLOW = '[app-checkout/Checkout] Init sofort flow',
  SOFORT_DETAILS = '[app-checkout/Checkout] Sofort capture details',
  CANCEL_SOFORT_FLOW = '[app-checkout/Checkout] Cancel sofort flow',
}

export class InitPayment implements Action {
  readonly type = PaymentActionTypes.INIT_PAYMENT;

  constructor(public payload:
    { address: { shippingAddress: Address; billingAddress: Address; freightforwardingPhone?: string; organizationVatNumber?: string }; }
  ) { }
}

export class InitPaymentSuccess implements Action {
  readonly type = PaymentActionTypes.INIT_PAYMENT_SUCCESS;

  constructor(public payload: { paymentWidgetConfig: AvailablePaymentMethods; lastPaymentMethodUsed: string }) { }
}

export class InitPaymentFailure implements Action {
  readonly type = PaymentActionTypes.INIT_PAYMENT_FAILURE;

  constructor(public payload: { error: ErrorResponse }) { }
}

export class MakePayment implements Action {
  readonly type = PaymentActionTypes.MAKE_PAYMENT;

  constructor(public payload: { payment: PaymentRequest, isAssistedSales?: boolean }) { }
}

export class MakePaymentSuccess implements Action {
  readonly type = PaymentActionTypes.MAKE_PAYMENT_SUCCESS;

  constructor(public payload: { payment: OrderPayment; request: PaymentRequest }) { }
}

export class InitAdyen3DSFlow implements Action {
  readonly type = PaymentActionTypes.INIT_ADYEN_3DS_FLOW;

  constructor(
    public payload: {
      challengeResponse: ChallengeResponse;
      orderNumber: string;
      challengeType: string;
    }
  ) { }
}

export class CancelAdyen3DSFlow implements Action {
  readonly type = PaymentActionTypes.CANCEL_ADYEN_3DS_FLOW;
}

export class Adyen3DSDetails implements Action {
  readonly type = PaymentActionTypes.ADYEN_3DS_DETAILS;

  constructor(public payload: ChallengeDetailsRequestModel) { }
}

export class MakePaymentFailure implements Action {
  readonly type = PaymentActionTypes.MAKE_PAYMENT_FAILURE;

  constructor(public payload: { error: any; request: PaymentRequest }) { }
}

export class MakePaymentOtherFailure implements Action {
  readonly type = PaymentActionTypes.MAKE_PAYMENT_OTHER_FAILURE;

  constructor(public payload: { error: any, paymentRequest?: any }) { }
}

export class InitPaypalFlow implements Action {
  readonly type = PaymentActionTypes.INIT_PAYPAL_FLOW;

  constructor(public payload: { challengeResponse: ChallengeResponse; orderNumber: string }) { }
}

export class PaypalDetails implements Action {
  readonly type = PaymentActionTypes.PAYPAL_DETAILS;

  constructor(public payload: ChallengeDetailsRequestModel) { }
}

export class CancelPaypalFlow implements Action {
  readonly type = PaymentActionTypes.CANCEL_PAYPAL_FLOW;
}

export class InitSofortFlow implements Action {
  readonly type = PaymentActionTypes.INIT_SOFORT_FLOW;

  constructor(public payload: { challengeResponse: ChallengeResponse; orderNumber: string; challengeType: string }) { }
}

export class SofortDetails implements Action {
  readonly type = PaymentActionTypes.SOFORT_DETAILS;

  constructor(public payload: ChallengeDetailsRequestModel) { }
}

export class CancelSofortFlow implements Action {
  readonly type = PaymentActionTypes.CANCEL_SOFORT_FLOW;
}

export type PaymentActions =
  | InitPayment
  | InitPaymentSuccess
  | InitPaymentFailure
  | MakePayment
  | MakePaymentSuccess
  | InitAdyen3DSFlow
  | CancelAdyen3DSFlow
  | Adyen3DSDetails
  | MakePaymentFailure
  | MakePaymentOtherFailure
  | InitPaypalFlow
  | PaypalDetails
  | CancelPaypalFlow
  | InitSofortFlow
  | SofortDetails
  | CancelSofortFlow;
